import React, { useContext, useMemo } from 'react';
import { GamesList, ProductPage } from '@homeplay/components';
import classes from './Club888.module.scss';
import logoClub888 from '../../../../shared/assets/images/logo-club888.png';
import { useSelector } from 'react-redux';
import { selectClub888Games, SiteContext } from '@homeplay/app';

//TODO: prod touch unit club888 games
export const club888GamesOnTouchUnit = [
  'gmwgoalkeno',
  'gmwsupaces',
  'gmwqcsolit',
  'gmwlecfrut',
  'gmwgoldegg',
  'gmwparbeads',
  'gmwdolpadv',
  'gmwmimoose',
  'gmwfirewks',
  'gmwpanache',
  'gmwpirisland',
  'gmwgoldland',
  'gmwballoon',
  'gmwgoldpig',
  'gmwwwkeno',
  'gmwstmkeno',
  'gmwaceface',
  'gmwfizpop',
  'gmwbandit',
  'gmwsodpop',
  'gmwgrwall',
  'gmwsugpop',
  'gmwvegsolit',
  'gmwbmyval',
  'gmwcleokeno',
  'gmwtribspir',
  'gmwshinknig',
  'gmwgreatemp',
  'gmwlicaact',
  'gmwhichspir',
  'gmwnapol',
  'gmwtrequest',
  'gmwgoldrab',
  'gmwmargraba',
  'gmwrabrun',
  'gmwknigsteel',
  'gmwmystqueen',
  'gmwangkor',
  'gmwmygeisec',
  'gmwberrybill',
  'gmwbeargam',
  'gmwtoys',
  'gmwhlands',
  'gmwlostcityatlantis',
  'gmwfrutxplos',
  'gmwbeerfest',
  'gmwghoghost',
  'gmwrainbowpop',
  'gmwblackjack5',
  'gmwfoxi',
  'gmwmoonmoney',
  'gmwdiamuert',
  'gmwshamvis',
  'gmwluckeast',
  'gmwgreatapes',
  'gmwfarolunfest',
  'gmwfedulunfest',
  'gmwxifulunfest',
  'gmwddpokbon',
  'gmwsevjokwild',
  'gmwdbondeucwild',
  'gmwdeucwild',
  'gmwsugbang',
  'gmwamafever',
  'gmwtajmahal',
  'gmworca',
  'gmwseatrtl',
  'gmwsupfruitsq',
  'gmwmarmin',
  'gmwsplenven',
  'gmwoctopus',
  'gmwbalantra',
  'gmwfrice',
  'gmwhappygolucky',
  'gmwjockgowild',
  'gmwkingcrab',
  'gmwprincejung',
  'gmwsecdesert',
  'gmwafrwild',
  'gmwblackjack',
  'gmwbonpoker',
  'gmwtensbetter',
  'gmwjacksbetter',
  'gmwsweetkdom',
  'gmwdickdet',
  'gmwsizzlfruit',
  'gmwravhot',
  'gmwbufrunq',
  'gmwlightfruitsq',
  'gmwneonnightq',
  'gmwafroditi',
  'gmwbailongma',
  'gmwbcasherup',
  'gmwblackpant',
  'gmwbonclown',
  'gmwbreakbank',
  'gmwdblmagic',
  'gmwdblvault',
  'gmwfantsev',
  'gmwfantgar',
  'gmwfoxyfox',
  'gmwgoldlion',
  'gmwjackquest',
  'gmwjadeemp',
  'gmwjestfort',
  'gmwluauluau',
  'gmwlucktimes',
  'gmwmegasev',
  'gmwmermluckchest',
  'gmwneonnightcl',
  'gmwprincjung',
  'gmwpuffking',
  'gmwrapreels',
  'gmwreddiam',
  'gmwreelsdx',
  'gmwsasqcash',
  'gmwsevgowild',
  'gmwsunwukong',
  'gmwtiti',
  'gmwtoucan',
  'gmwwhirlcash',
  'gmwwinfruits',
  'gmwtrecove',
  'gmwprincdeep',
  'gmwmagfairdx',
  'gmwdbljokmoney',
  'gmwluckjest',
  'gmwphoenix',
  'gmwwildred',
  'gmwgriffin',
  'gmwdblblackcher',
  'gmwsupnine',
  'gmwpegasus',
  'gmwtencrowns',
  'gmwdiamonddx',
  'gmwkingdeep',
  'gmwlivdream',
  'gmwsacflo',
  'gmwmeganine',
  'gmwspecsev',
  'gmwolympus',
  'gmwlightfruits',
  'gmwxdiamondsdx',
  'gmwyinyang',
  'gmwwildsafari',
  'gmwneonnight',
  'gmwposeidon',
  'gmwmaydreams',
  'gmwspartfinstand',
  'gmwindianchief',
  'gmw101lions',
  'gmwwildcleodx',
  'gmwbufrun',
  'gmwred',
  'gmwtentigers',
  'gmwhotfro',
  'gmwviking',
  'gmwdragat',
  'gmwsupeight',
  'gmwgoldrag',
  'gmwmarantoin',
  'gmwarcwolf',
  'gmwwolfpack',
  'gmwmagsig',
  'gmwmermmelod',
  'gmwcircar',
  'gmwbarrich',
  'gmwamewild',
  'gmwzuluking',
  'gmwrhino',
  'gmwsacowl',
  'gmwdowund',
  'gmwgladia',
  'gmwspot',
  'gmwjester',
  'gmwsilsan',
  'gmwmasque',
  'gmwkassan',
  'gmwelpatr',
  'gmwsupfruits',
  'gmwkingcairodx',
  'gmwsmlvil',
  'gmwserget',
  'gmwblkprl',
  'gmwamore',
  'gmwsupsev',
  'gmwwilder',
  'gmwantfam',
  'gmw101wolf',
  'gmwasgard',
];

const Club888 = () => {
  const { isTouchUnit } = useContext(SiteContext);
  const club888Games = useSelector(selectClub888Games);

  const updatedClub888Games = useMemo(() => {
    if (isTouchUnit && process.env.REACT_APP_ENV === 'prod') {
      return (
        club888Games?.filter((game) =>
          club888GamesOnTouchUnit.includes(game.slug)
        ) ?? []
      );
    }
    return club888Games;
  }, [club888Games, isTouchUnit]);

  const getGameLink = (loadParams, vendorData, exitUrl) => {
    let baseUrl = `${process.env.REACT_APP_CLUB888_BASE_URL}/loader`;
    let lobbyUrl = exitUrl;
    if (vendorData.altloader) {
      baseUrl = `${process.env.REACT_APP_CLUB888_NEW_BASE_URL}/loader/index.html`;
      lobbyUrl = `${window.location.origin}/exit`;
    }

    return `${baseUrl}?gameid=${vendorData.gameid}&token=${loadParams.player_token}&lobbyurl=${lobbyUrl}&lang=en`;
  };

  return (
    <ProductPage getGameLink={getGameLink} customClass={classes.Club888}>
      <div className="container">
        <img
          className={classes.Logo}
          src={logoClub888}
          alt="Club888"
          width="322"
          height="90"
        />
        {updatedClub888Games && <GamesList games={updatedClub888Games} />}
      </div>
    </ProductPage>
  );
};

export default Club888;
